/** Descriptions shown in chart tooltips */
export const metricDesc: Record<string, string> = {
  // Social - general
  "Engagement": "Celkový počet interakcí (reakce, komentáře, sdílení, kliky)",
  "Facebook": "Engagement z Facebook příspěvků",
  "Instagram": "Engagement z Instagram příspěvků",
  "Dosah": "Počet unikátních uživatelů, kteří viděli příspěvek",
  "Zobrazení": "Celkový počet zobrazení (včetně opakovaných)",

  // Facebook
  "Reakce": "Celkový počet reakcí (like, love, haha, wow...)",
  "Komentáře": "Počet komentářů pod příspěvkem",
  "Sdílení": "Kolikrát byl příspěvek sdílen",
  "Kliky": "Počet kliknutí na příspěvek (odkaz, foto, zobrazit více...)",
  "Video zhlédnutí": "Počet zhlédnutí videa (min. 3 sekundy)",

  // Instagram
  "Lajky": "Počet lajků na příspěvku",
  "Uložení": "Kolikrát si uživatelé příspěvek uložili",
  "Přehrání": "Celkový počet přehrání videa/reels",
  "Zhlédnutí": "Počet zhlédnutí Reels videa",

  // GA4
  "Sessions": "Počet návštěv webu (session = souvislá aktivita uživatele)",
  "Uživatelé": "Počet unikátních návštěvníků",
  "Noví": "Uživatelé, kteří web navštívili poprvé",
  "Noví uživatelé": "Uživatelé, kteří web navštívili poprvé",
  "Zobrazení stránek": "Celkový počet zobrazených stránek",
  "Bounce Rate": "Procento návštěv, kdy uživatel odešel bez interakce",
  "Engagement Rate": "Procento návštěv s aktivním zapojením (scroll, klik, 10s+)",
  "Konverze": "Celkový počet splněných cílů (rezervace, nákup, registrace...)",
  "Nákupy": "Počet dokončených nákupů/objednávek",
  "Poukazy": "Počet zakoupených poukazů",

  // Traffic
  "Organic": "Návštěvy z vyhledávačů (Google, Seznam...)",
  "Organic Search": "Návštěvy z vyhledávačů (Google, Seznam...)",
  "Direct": "Přímé návštěvy (zadání URL, záložky)",
  "Organic Social": "Návštěvy ze sociálních sítí (neplacené)",
  "Email": "Návštěvy z emailových kampaní",
  "Referral": "Návštěvy z odkazů na jiných webech",
  "Paid Search": "Návštěvy z placené reklamy ve vyhledávání",

  // Misc
  "Počet": "Počet příspěvků daného typu",
  "Prům. engagement": "Průměrný engagement na příspěvek",
  "Celkem": "Celkový počet konverzí",
  "Hodnota": "Naměřená hodnota",
};
